/** Whole-dollar comparison of exact USD cents; half dollars round away from zero. */
export function roundUsdCentsToDollars(cents: bigint): bigint {
  return cents < 0n ? -((-cents + 50n) / 100n) : (cents + 50n) / 100n;
}
/** Decision equality is dollar-rounded; a sub-dollar difference is never a finding. */
export function dollarRoundedMoneyGap(leftCents: bigint, rightCents: bigint): bigint {
  const difference = leftCents - rightCents;
  if (difference > -100n && difference < 100n) return 0n;
  return (roundUsdCentsToDollars(leftCents) - roundUsdCentsToDollars(rightCents)) * 100n;
}

export function moneyEqualAtDollar(leftCents: bigint, rightCents: bigint): boolean {
  return dollarRoundedMoneyGap(leftCents, rightCents) === 0n;
}
